import React from 'react'
import Card from '../components/Payment/Card'

function CardPage() {
  return (
    <>
    <Card/>
    </>
  )
}

export default CardPage
